import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { InvoiceStatusEnum } from "../../data/enums";

export namespace MarketingInvoiceValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.picklist(InvoiceStatusEnum.values)),
                minDate: v.optional(baseVals.isoDate()),
                maxDate: v.optional(baseVals.isoDate()),
            }),
        }),
    );
}
